import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isLongTitle } from '../../helpers';

import s from './Title.scss';

export interface Props {
  title?: string;
  showTitle?: boolean;
  className?: string;
}

const Title: React.FC<Props> = ({ title, showTitle, className }) => {
  const isMobile = useContext(MobileContext);

  if (!title || !showTitle) {
    return isMobile ? null : <div className={className} />;
  }

  return (
    <h1 className={classnames(s['root'], isLongTitle(title) && s['long'], className)}>{title}</h1>
  );
};
Title.displayName = 'Title';

export default Title;
